export default {
  NoCalculation: 'noCalculation',
  AverageInventoryValue: 'averageOfInventoryValue',
  LastReceivedPrice: 'lastPriceReceived',
}
